module.exports = __webpack_public_path__ + "img/bg_auido_cover.0558e2f1.png";